angular.module('impactx.attributes').directive('ixPatAttributes', function ()
{
    return {
        scope: {
            patAttributes: "=",
            dialogData: "=",
            headerLabel: "=",
            noEditMessage: "=",
            onlyInner: "=",
            requiredMessage: "@",
            errorList: "=",
            guiId: "@",
            readOnly: "="
        },
        restrict: 'E',
        controller: 'PatCtrl',
        controllerAs: 'patCtrl',
        templateUrl: 'shared/attributes/templates/patattributes.tmpl.html',
        transclude: true
    };
});